import { Paragraph } from '@eggplant/pattern-library'

const EmptyStateDescription = () =>
  <Paragraph>
    Try updating your search criteria.
  </Paragraph>

export default EmptyStateDescription
